"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoneData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class BoneData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #region Constructors (1)
    /**
     * Creates a Bone data node.
     *
     * @param id the id
     */
    constructor(id, version) {
        super(id, version);
    }
    // #endregion Constructors (1)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new BoneData(this.id, this.version);
    }
}
exports.BoneData = BoneData;
//# sourceMappingURL=BoneData.js.map